import clsx from 'clsx'
import React from 'react'
import { useNavigate } from 'react-router-dom'

interface TryButtonProps {
  withShadow?: boolean
  text?: string
  to?: string
  onClick?: () => void
  disabled?: boolean
  isWhitePage?: boolean
  large?: boolean
}

const TryButtonBrand = (props: TryButtonProps) => {
  const navigate = useNavigate()
  return (
    <button
      onClick={props.onClick ? props.onClick : () => navigate(props.to ?? '/scan-results')}
      disabled={props.disabled}
      className={clsx(
        'text-center main-button w-full h-14 py-3.5 px-4 rounded-4xl text-black dark:text-white bg-buttonGradient text-[20px] font-bold transition-colors duration-200',
        {
          'shadow-[10px_10px_50px_0px_rgba(253,211,62,0.4)] ': props.withShadow,
          '!bg-[#FBFBFB1F] !text-[#A1A1A1] transition-colors duration-200': props.disabled,
          'text-[20px]': props.large,
        },
      )}
    >
      {props.text ?? 'Try Clean Master Now'}
    </button>
  )
}

export default TryButtonBrand
